import { addResources } from "src/lib/i18next/addResources.ts";
import { i18n } from "src/lib/i18next/i18next.ts";
import { logger } from "src/logger";
import { getTranslationsPath } from "src/lib/i18next/getTranslationsPath.ts";

const defaultLangs = ["en", "de"];
export const loadTranslations = async (
  ns: string,
  langs: string[] = defaultLangs,
) => {
  const jsonFiles = import.meta.glob("/src/**/*.json");
  const translations = await Promise.all(
    langs.map(async (lang) => {
      const key = "/" + getTranslationsPath(ns, lang);
      const loadTranslationsFn = jsonFiles[key];
      if (!loadTranslationsFn) {
        logger.error(
          `translations for [${ns}] namespace not found in following [${key}] location`,
        );
        return {};
      }

      return loadTranslationsFn();
    }),
  );

  const resources = langs.reduce((acc, lang, index) => {
    return {
      ...acc,
      [lang]: translations[index],
    };
  }, {});

  addResources(i18n, ns, resources);

  return resources;
};
